import React from "react";
import { IonContent, IonPage } from "@ionic/react";
import Header from "../components/Header";
import { HELP_DATA } from "../stores/help.store";
import HelpAccordion from "../components/HelpAccordian";
import AnimationContainer from "../components/Animation";

const HelpCenterPage: React.FC = () => {
  return (
    <>
      <IonPage>
        <Header title="Help Center" />
        <IonContent fullscreen>
          <AnimationContainer animationName="botAnimation" />
          <HelpAccordion helpData={HELP_DATA} />
        </IonContent>
      </IonPage>
    </>
  );
};

export default HelpCenterPage;
